import React, { useState } from "react";
import { Lock, X } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../../contexts/AuthContext";

export default function ChangePasswordModal({ open, onClose, forced = false }) {
  const { changePassword } = useAuth();
  const [oldPw, setOldPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [busy, setBusy] = useState(false);

  if (!open) return null;

  const submit = async (e) => {
    e?.preventDefault();
    if (newPw.length < 8) return toast.error("Passwort muss mindestens 8 Zeichen haben.");
    if (newPw !== confirmPw) return toast.error("Passwörter stimmen nicht überein.");
    setBusy(true);
    try {
      await changePassword(oldPw, newPw);
      toast.success("Passwort gespeichert.");
      setOldPw(""); setNewPw(""); setConfirmPw("");
      onClose?.();
    } catch (ex) {
      toast.error(ex?.response?.data?.detail || "Passwortwechsel fehlgeschlagen.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <div onClick={forced ? undefined : onClose} className="fixed inset-0 bg-navy/40 z-40" />
      <div
        data-testid="change-password-modal"
        className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[min(440px,95vw)] bg-white border border-navy/15 z-50"
      >
        <div className="border-b border-navy/10 px-6 py-4 flex items-start justify-between">
          <div>
            <div className="pb-eyebrow flex items-center gap-1.5">
              <Lock size={11} /> Sicherheit
            </div>
            <h3 className="font-display font-semibold text-navy text-xl mt-1 tracking-tight">
              {forced ? "Bitte neues Passwort setzen" : "Passwort ändern"}
            </h3>
            {forced && (
              <p className="text-xs text-navy/55 font-sans mt-1">
                Initial-Passwort muss vor der weiteren Nutzung gewechselt werden.
              </p>
            )}
          </div>
          {!forced && (
            <button data-testid="change-pw-close" onClick={onClose} aria-label="Modal schließen" className="text-navy/60 hover:text-navy min-w-[44px] min-h-[44px] -mr-2.5 inline-flex items-center justify-center">
              <X size={18} />
            </button>
          )}
        </div>
        <form onSubmit={submit} className="px-6 py-5 space-y-4">
          <div>
            <label className="pb-label">Altes Passwort</label>
            <input
              data-testid="cp-old"
              type="password"
              autoFocus
              value={oldPw}
              onChange={(e) => setOldPw(e.target.value)}
              className="pb-input--full"
            />
          </div>
          <div>
            <label className="pb-label">Neues Passwort</label>
            <input
              data-testid="cp-new"
              type="password"
              value={newPw}
              onChange={(e) => setNewPw(e.target.value)}
              className="pb-input--full"
              minLength={8}
            />
          </div>
          <div>
            <label className="pb-label">Neues Passwort wiederholen</label>
            <input
              data-testid="cp-new2"
              type="password"
              value={confirmPw}
              onChange={(e) => setConfirmPw(e.target.value)}
              className="pb-input--full"
              minLength={8}
            />
          </div>
          <div className="flex justify-end gap-2 pt-2 border-t border-navy/10">
            {!forced && (
              <button type="button" onClick={onClose} className="pb-btn-ghost">Abbrechen</button>
            )}
            <button data-testid="cp-submit" type="submit" disabled={busy} className="pb-btn-primary">
              {busy ? "…" : "Speichern"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
